import { render, staticRenderFns } from "./list.vue?vue&type=template&id=ea72dd2e&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=ea72dd2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea72dd2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea72dd2e')) {
      api.createRecord('ea72dd2e', component.options)
    } else {
      api.reload('ea72dd2e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=ea72dd2e&scoped=true&", function () {
      api.rerender('ea72dd2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fude/list.vue"
export default component.exports